export enum PromiseStatus {
	Fulfilled = "fulfilled",
	Rejected = "rejected",
}
